import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { sxModal } from './sxProps';
import './styles.css'
import { ErrorModalProps } from '../../../interfaces/props/SaudeOnline/ErrorModalProps';
import CheckIcon from './CheckIcon';

function SucessContactEditModal(props: ErrorModalProps) {
    
    const handleCloseModal = () => {
        props.handleCloseModal();
    }


    return (

        <div>
            <Modal
                open={props.open}
                onClose={handleCloseModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={sxModal}>
                    <div className="confirmation-feedback-modal-header">
                        <button className='confirmation-modal-header-close' onClick={handleCloseModal}><FontAwesomeIcon icon={faTimes} /></button>
                    </div>
                    <div className="confirmation-feedback-modal-info">
                        <CheckIcon/>
                    </div>
                    <h1 className="confirmation-feedback-modal-title">
                        Seus dados de contato foram atualizados com sucesso!
                    </h1>
                </Box>
            </Modal>
        </div>
      );
}

export default SucessContactEditModal;